import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseResponse, BaseResponseObj } from 'ccc-commons/dist/core';
import { Role } from '../models/role.model';

@Injectable()
export class RoleService {
  apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }


  getRoles(orgId: string): Observable<BaseResponse<Role>> {
    return this.http.get<BaseResponse<Role>>(`${this.apiUrl}/organizations/${orgId}/roles`);
  }

  createRole(orgId: string, role: any): Observable<BaseResponseObj<Role>> {
    return this.http.post<BaseResponseObj<Role>>(`${this.apiUrl}/organizations/${orgId}/roles`, role);
  }

  updateRole(roleId: string, role: any): Observable<BaseResponse<Role>> {
    return this.http.put<BaseResponse<Role>>(`${this.apiUrl}/roles/${roleId}`, role);
  }

  updateRolesLocationsBelow(orgId): Observable<BaseResponseObj<Role>> {
    return this.http.patch<BaseResponseObj<Role>>(
      `${environment.apiUrl}/organizations/${orgId}/roles`,
      {}
    );
  }

}
